/**
 * Global quick links for navbar search.
 *
 * Iterate by adding/removing entries and aliases here without touching
 * GlobalSearch search logic.
 */
export const globalSearchQuickLinks = [
  {
    id: "personality-assessment",
    labelId: "global-search-link-personality-assessment",
    defaultLabel: "Interest Profiler",
    path: "/dashboard?tab=assessment",
    categoryKey: "assessments",
    categoryLabelId: "global-search-quick-links-category-assessments",
    categoryDefaultLabel: "Assessments",
    aliases: {
      "en-US": [
        "interest profiler",
        "interest profile",
        "personality quiz",
        "interest assessment",
        "career assessment",
        "personality assessment",
        "career quiz",
        "quiz",
      ],
      "es-ES": [
        "perfil de intereses",
        "evaluacion de personalidad",
        "quiz de personalidad",
        "prueba de carrera",
        "quiz",
        "evaluacion de intereses", 
        "evaluacion de carrera", 
        "evaluacion de personalidad",
      ],
    },
  },
  {
    id: "explore-people",
    labelId: "global-search-link-explore-people",
    defaultLabel: "Explore People",
    path: "/dashboard?tab=explore&category=People",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["people", "explore people", "stories", "career stories"],
      "es-ES": ["personas", "explorar personas", "historias", "historias de carrera"],
    },
  },
  {
    id: "explore-careers",
    labelId: "global-search-link-explore-careers",
    defaultLabel: "Explore Careers",
    path: "/dashboard?tab=explore&category=Careers",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["careers", "explore careers", "career list", "career exploration"],
      "es-ES": ["carreras", "explorar carreras", "lista de carreras", "exploracion de carreras"],
    },
  },
  {
    id: "explore-schools",
    labelId: "global-search-link-explore-schools",
    defaultLabel: "Explore Schools",
    path: "/dashboard?tab=explore&category=Schools",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["schools", "explore schools", "college search", "school search"],
      "es-ES": ["escuelas", "explorar escuelas", "buscar universidad", "buscar escuela"],
    },
  },
  {
    id: "explore-majors",
    labelId: "global-search-link-explore-majors",
    defaultLabel: "Explore Majors",
    path: "/dashboard?tab=explore&category=Majors",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["majors", "explore majors", "major search", "degree paths"],
      "es-ES": ["especializaciones", "explorar especializaciones", "buscar especializacion", "rutas de titulacion"],
    },
  },
  {
    id: "explore-companies",
    labelId: "global-search-link-explore-companies",
    defaultLabel: "Explore Companies",
    path: "/dashboard?tab=explore&category=Companies",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["companies", "explore companies", "employers", "company search"],
      "es-ES": ["empresas", "explorar empresas", "empleadores", "buscar empresas"],
    },
  },
  {
    id: "explore-videos",
    labelId: "global-search-link-explore-videos",
    defaultLabel: "Explore Videos",
    path: "/dashboard?tab=explore&category=Videos",
    categoryKey: "exploration",
    categoryLabelId: "global-search-quick-links-category-exploration",
    categoryDefaultLabel: "Exploration",
    aliases: {
      "en-US": ["videos", "explore videos", "watch stories", "career videos"],
      "es-ES": ["videos", "explorar videos", "ver historias", "videos de carrera"],
    },
  },
  {
    id: "skills-development",
    labelId: "global-search-link-skills-development",
    defaultLabel: "Skills Development",
    path: "/dashboard?tab=work-readiness",
    categoryKey: "development",
    categoryLabelId: "global-search-quick-links-category-development",
    categoryDefaultLabel: "Development",
    aliases: {
      "en-US": ["work readiness", "skill building", "employability skills", "modules", "programs", "assignments"],
      "es-ES": ["preparacion laboral", "desarrollo de habilidades", "empleabilidad", "modulos", "programas", "tareas"],
    },
  },
  {
    id: "resume-builder",
    labelId: "global-search-link-resume-builder",
    defaultLabel: "Resume Builder",
    path: "/dashboard/?tab=portfolio",
    categoryKey: "documents",
    categoryLabelId: "global-search-quick-links-category-documents",
    categoryDefaultLabel: "Documents",
    aliases: {
      "en-US": ["resume", "resumes", "cv", "portfolio", "portfolios", "resume maker", "resume builder"],
      "es-ES": ["curriculum", "curriculums", "cv", "hoja de vida", "portafolio", "portafolios"],
    },
  },
  {
    id: "career-plans",
    labelId: "global-search-link-career-plans",
    defaultLabel: "Career Plans",
    path: "/dashboard?tab=career-plan",
    categoryKey: "planning",
    categoryLabelId: "global-search-quick-links-category-planning",
    categoryDefaultLabel: "Planning",
    aliases: {
      "en-US": ["action plan", "plan my career", "career pathway plan"],
      "es-ES": ["plan de accion", "plan de carrera", "ruta profesional"],
    },
  },
  {
    id: "goal-tracking",
    labelId: "global-search-link-goal-tracking",
    defaultLabel: "Goal Tracking",
    path: "/dashboard?tab=goal-tracking",
    categoryKey: "planning",
    categoryLabelId: "global-search-quick-links-category-planning",
    categoryDefaultLabel: "Planning",
    aliases: {
      "en-US": ["goals", "goal tracker", "track my goals", "milestones"],
      "es-ES": ["metas", "seguimiento de metas", "objetivos", "hitos"],
    },
  },
  {
    id: "tal-e",
    labelId: "global-search-link-tal-e",
    defaultLabel: "TAL-E Experience Translator",
    path: "/tal-e",
    categoryKey: "development",
    categoryLabelId: "global-search-quick-links-category-development",
    categoryDefaultLabel: "Development",
    aliases: {
      "en-US": [
        "tal-e",
        "tale",
        "experience translator",
        "skills translator",
        "skill translator",
        "translate my experience",
      ],
      "es-ES": [
        "tal-e",
        "tale",
        "traductor de experiencia",
        "traductor de experiencias",
        "traducir mi experiencia",
      ],
    },
  },
]
